// extracted by mini-css-extract-plugin
export default {"popover":"MjLdUuwl1RzIPgOtVTYM+w=="};